import { isGlobalworth, paths } from 'config'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'
import { Building, DrawerBuilding } from 'shared/assets'

const routes: ModuleRoute[] = [
  {
    path: paths.buildings,
    admin: false,
    exact: true,
    linkSettings: {
      icon: isGlobalworth ? Building : DrawerBuilding,
      label: 'nav.building',
    },
    component: Loadable({
      component: () => import('./pages/Buildings'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.building,
    admin: false,
    exact: true,
    component: Loadable({
      component: () => import('./pages/Building'),
    }),
    layoutSettings: {},
  },
]

export default routes
